import { render, staticRenderFns } from "./drawer-menu.vue?vue&type=template&id=00c47042&"
import script from "./drawer-menu.vue?vue&type=script&lang=js&"
export * from "./drawer-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "drawer-menu.vue"
export default component.exports